import React from 'react';
import PropTypes from 'prop-types';

export const HCPSignupFormWrapper = ({ error, children }) => (
  <React.Fragment>
    <div className="hcp-signup-form-wrapper">{children}</div>
    {error ? <div className="hcp-signup-error-handling">{error}</div> : null}
  </React.Fragment>
);

HCPSignupFormWrapper.propTypes = {
  error: PropTypes.any,
  children: PropTypes.any.isRequired,
};
